import { useState, useContext } from "react";
import { Button, Card, Alert, ProgressBar } from "react-bootstrap";
import { UserContext, Utils } from "./../../common";
import axios from "axios";

const IAgree = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(false);
  const { addToUserData } = useContext(UserContext);
  const iDoAgree = () => {
    axios
      .post(Utils.apiUrl("users/idoagree"), `agree=1`, Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setMessage({ type: "success", message: res.data.message });
          addToUserData({ first: parseInt(res.data.first) === 1 }, () => {
            //window.setTimeout(() => window.location.reload(), 2000);
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        setMessage({ type: "danger", message: err.message });
      });
  };

  return (
    <div className="mt-4">
      {message && (
        <Alert variant={message.type} className="p-3">
          {message.message}
        </Alert>
      )}
      {loading && (
        <Alert variant="info" className="p-3">
          <p className="loading-msg">processing..</p>
          <ProgressBar variant="info" animated now={100} />
        </Alert>
      )}
      {!loading && (
        <Card className="mh-100">
          <Card.Body>
            <h1 className="px-1">DENTTRACK END USER LICENCE AGREEMENT</h1>
            <div className="px-1 mb-1">
              <b>To Access DenTTrack Services - Please Agree to Terms and Conditions Below</b>
              <img src={`${process.env.PUBLIC_URL}/images/arrow-down.png`} alt="scroll down" />
            </div>
            <hr className="my-0 ms-1" />
            <div className="p-2 mb-2 agreetext">
              <div className="contentlist">
                <p>
                  <b>
                    PLEASE READ THIS AGREEMENT CAREFULLY. This is a legally binding agreement between you ("Licensee" or "you") and Denttrack Pvt
                    Limited ("Licensor", "we" or "us"), granting you a licence (the "Licence") for the Denttrack software, including any free Updates,
                    Upgrades, patches, fixes or workarounds made available by the Licensor under this Agreement, and any data, media or documents
                    associated with it (together "Denttrack").
                  </b>
                </p>
                <p>
                  <b>
                    For the avoidance of doubt, this Licence shall not be deemed to amount to a sale of Denttrack, in whole or in part, or any of the
                    Intellectual Property Rights to Denttrack which shall remain vested in us at all time. We remain the sole and beneficial owners of
                    Denttrack at all times.
                  </b>
                </p>
                <p>
                  <b>
                    BY CLICKING ‘ACCEPT' YOU AGREE TO AND ACCEPT THE TERMS OF THIS AGREEMENT WHICH WILL BE BINDING ON YOU AND ANY OF YOUR AUTHORISED
                    USERS WHEN ACCESSING OR USING THE SOFTWARE. IF YOU DO NOT AGREE TO ANY OF THE TERMS OF THIS AGREEMENT YOU SHOULD NOT PROCEED WITH
                    PAYMENT OR USE OF DENTTRACK.
                  </b>
                </p>
                <p>
                  This Agreement shall constitute the entire agreement between you and us relating to your Use of Denttrack and it supersedes all
                  previous communications, representations and arrangements, either written or oral. This Agreement cannot be varied or replaced by
                  terms and conditions in purchase orders or similar documents.
                </p>

                <div className="contentdetails">
                  <h2>1. Definitions </h2>
                  <p>In this Agreement:</p>
                  <p>
                    "<b>Authorised Users</b>" means your personnel who are authorised to access and use Denttrack under this Agreement. You are
                    responsible for any breaches of this Agreement by your Authorised Users.
                  </p>
                  <p>
                    "<b>Business Day</b>" means a day other than a Saturday, Sunday or public holiday in England.
                  </p>
                  <p>
                    "<b>Confidential Information</b>" means all information relating to a party's business which may reasonably be considered to be
                    confidential in nature including information relating to that party's technology, know-how, Intellectual Property Rights, products
                    and customers. All information relating to the Software including any technical or operational specifications or data shall be
                    part of the Licensor's Confidential Information.
                  </p>
                  <p>
                    "<b>Content</b>" means resources available to you on Denttrack.
                  </p>
                  <p>
                    "<b>Content Contributor</b>" means the Licensor or third party authors of the Content.
                  </p>
                  <p>
                    "<b>Effective Date</b>" means the date on which you click "Accept" to this Agreement.
                  </p>
                  <p>
                    "<b>Fees</b>" means the fees payable in advance by you to us in consideration of the licence to Use Denttrack and the Content
                    under the terms of this Agreement.
                  </p>
                  <p>
                    "<b>Intellectual Property Rights</b>" means any and all copyright, rights in inventions, patents, know-how, trade secrets,
                    trademarks and trade names, service marks, design rights, rights in get-up, database rights and rights in data, semiconductor chip
                    topography rights, utility models, domain names and all similar rights and, in each case:
                  </p>
                  <ul className="listnone">
                    <li>(a) whether registered or not;</li>
                    <li>(b) including any applications to protect or register such rights;</li>
                    <li>(c) including all renewals and extensions of such rights or applications;</li>
                    <li>(d) whether vested, contingent or future; and</li>
                    <li>(e) wherever existing.</li>
                  </ul>
                  <p>
                    "<b>Permitted Usage Rights</b>" means the permitted number of concurrent users and the Denttrack benefits and features available
                    to you under the level of membership you choose on the Effective Date.
                  </p>
                  <p>
                    "<b>Use</b>" means to access, connect to, download and use Denttrack.
                  </p>
                  <p>
                    "<b>Term</b>" means the Initial Term and any Renewal Terms as defined in clause 2.
                  </p>
                  <p>
                    "<b>Third Party Software</b>" means any third party software in Denttrack.
                  </p>
                  <p>
                    "<b>Update</b>" means a software maintenance update, patch or bug-fix which does not constitute an Upgrade.
                  </p>
                  <p>
                    "<b>Upgrade</b>" means a version or release of software intended to have new or improved functionality or designated by the
                    Licensor as an upgrade.
                  </p>
                  <p>
                    "<b>VAT</b>" means United Kingdom value added tax, any other tax imposed in substitution for it and any equivalent or similar tax
                    imposed outside the United Kingdom.
                  </p>

                  <h2>2. Term </h2>
                  <p>
                    2.1. This Agreement commence on the Effective Date and shall continue for one (1) calendar year from that date ("
                    <b>Initial Term</b>"). Following expiry of the Initial Term, this Agreement shall renew automatically for further successive
                    renewal periods of one (1) calendar year each (each calendar year is a "<b>Renewal Term</b>") unless not less than three (3)
                    months' notice of termination is given by one party to the other before the expiry of the Initial Term or the applicable Renewal
                    Term.
                  </p>

                  <h2>3. Permitted Use</h2>
                  <p>3.1. Except as expressly permitted under this Agreement or by law, you shall not:</p>
                  <ul className="listnone2">
                    <li>3.1.1. use, copy, modify, adapt, correct errors, or create derivative works from, Denttrack or the Content;</li>
                    <li>
                      3.1.2. decode, reverse engineer, disassemble, decompile or otherwise translate, or make alterations to, the Denttrack software
                      or otherwise seek to obtain or derive the source code, underlying ideas, algorithms, file formats or non-public APIs to the
                      Denttrack software, other than as expressly permitted under sections 50B and 296A of the Copyright Designs and Patents Act 1988
                      (and then only upon advance notice in writing to us);
                    </li>
                    <li>
                      3.1.3. assign, commercialise, rent, loan, transfer, provide access to, sub-licence, lease, resell, distribute or otherwise deal
                      in or encumber the Denttrack software;
                    </li>
                    <li>
                      3.1.4. remove or modify any copyright or similar notices of the Licensor's or Content Provider's on Denttrack or the Content;
                    </li>
                    <li>
                      3.1.5. Use Denttrack, or permit it to be Used by or on behalf of any third party, otherwise than for your internal business
                      purposes; or
                    </li>
                    <li>
                      3.1.6. interfere with any license key mechanism in the Denttrack software or otherwise attempt to circumvent or interfere with
                      any security features of the Denttrack software or mechanisms intended to limit your use.
                    </li>
                    <li>
                      3.2. You shall not exceed the Permitted Usage Rights and you acknowledge that you shall be required, without prejudice to any
                      other rights or remedies to which we may be entitled, to pay us at our then current rates for any additional usage of Denttrack.
                    </li>
                    <li>
                      3.3. You shall Use Denttrack at all times in accordance with any instructions or user guidance and all other terms of this
                      Agreement.
                    </li>
                    <li>
                      3.4. You shall notify us in writing as soon as you become aware of any actual or suspected unauthorised use of Denttrack
                      (including any use in excess of the Permitted Usage Rights).
                    </li>
                    <li>
                      3.5. Notwithstanding clause 3.1.1, you and your Authorised Users may make copies, modifications and create derivative works from
                      the Content to the extent necessary for internal business purposes.
                    </li>
                  </ul>

                  <h2>4. Authorised Users </h2>
                  <ul className="listnone">
                    <li>4.1. You shall ensure that each Authorised User is aware of and complies with the terms of this Agreement. </li>
                    <li>
                      4.2. You shall provide each Authorised User with a unique username and password to access Denttrack. Authorised Users may not
                      share their registered password or give access to Denttrack or Content to any other person.
                    </li>
                  </ul>

                  <h2>5. Intellectual Property Rights </h2>
                  <ul className="listnone">
                    <li>
                      5.1. All Intellectual Property Rights in Denttrack shall be and remain vested in the Licensor and all Intellectual Property
                      Rights in the Content shall be and remain vested in the Content Contributor.
                    </li>
                    <li>
                      5.2. No intellectual property rights Denttrack or the Content are transferred to you or your Authorised Users and nothing in
                      this Agreement is intended to assign or transfer any title or interest (including legal or equitable) in Denttrack or the
                      Content and their Intellectual Property Rights to you or your Authorised Users. You shall notify us immediately if you become
                      aware of any unauthorised use of the whole or any part of the Licensor's or Content Contributor's Intellectual Property Rights.
                    </li>
                    <li>
                      5.3. We hereby grant you a non-exclusive, non-transferable, revocable licence to use Denttrack and the Content in accordance
                      with this Agreement. Denttrack and the Content are for your personal use and use in the ordinary course of your business. You
                      are not permitted to use Denttrack and the Content for commercial exploitation or for use in a competing product or service.
                    </li>
                    <li>
                      5.4. From time to time, the Content Contributors will provide updates to the Content such as amendments to existing content to
                      reflect any regulatory or legal changes, provision of new content or removal of Content which is no longer compliant due to
                      regulatory or legal changes. It is your responsibility to check for such updates. We may, at our discretion change, remove,
                      suspend or discontinue any aspect of Denttrack or the Content at any time, including the availability of any Content.
                    </li>
                    <li>
                      5.5. No advice. Denttrack and the Content should not be considered a substitute for bespoke advisory or consultancy services.
                    </li>
                    <li>
                      5.6. We disclaim any and all liability resulting from misuse of Denttrack and the Content, which includes making edits, changes
                      or deletions to the Content in part or whole.
                    </li>
                  </ul>

                  <h2>6. Privacy Policy </h2>
                  <ul className="listnone">
                    <li>
                      6.1. All information obtained by us in connection with your use of Denttrack, including information about Authorised Users,
                      shall be used by us in accordance with our privacy policy. Please read this for details of how we may process personal data.
                    </li>
                    <li>
                      6.2. You acknowledge and agree, Denttrack is not intended for processing or storing information and data (including personal
                      data) about your patients. Any upload or storage of your patient information on Denttrack shall be deemed unauthorised Use of
                      Denttrack.
                    </li>
                  </ul>

                  <h2>7. Payment </h2>
                  <ul className="listnone">
                    <li>
                      7.1. Fees shall be payable by you monthly in advance. The fees are exclusive of amounts in respect of any applicable value added
                      tax ("VAT") and/or sales tax.
                    </li>
                    <li>7.2. We may increase the applicable fees for any Renewal Term. </li>
                  </ul>

                  <h2>8. Termination for cause</h2>
                  <ul className="listnone">
                    <li>
                      8.1. We may terminate this Agreement at any time by giving you notice in writing if you commit a material breach which is: (a)
                      not remediable; or (b) in the case of a remediable material breach, it is not remedied within ten (10) Business Days of
                      receiving notice of such breach.
                    </li>
                  </ul>

                  <h2>9. Consequences of termination</h2>
                  <p>
                    9.1. Immediately on termination or expiry of this Agreement (for any reason), the licences and rights granted by us shall
                    terminate and you shall (and, if applicable, shall procure that each Authorised User shall):
                  </p>
                  <ul className="listnone2">
                    <li>
                      9.1.1. stop Using, uninstall, delete or otherwise remove Denttrack from all computers or devices in your and any Authorised
                      User's possession or control; and
                    </li>
                    <li>
                      9.1.2. if we so request, provide us with written confirmation to us that you and any Authorised Users have complied with clause
                      9.1.1.
                    </li>
                  </ul>
                  <ul className="listnone">
                    <li>
                      9.2. You shall be responsible for backing up your data regularly and extracting it from Denttrack prior to the termination or
                      expiry of this Agreement. We shall not be obliged to provide you with any assistance extracting or recovering data whether
                      during or after the Licence Term.
                    </li>
                    <li>
                      9.3. Notwithstanding clause 9.2, if upon termination or expiry of this Agreement you reasonably request us to download and
                      deliver to you your data stored on Denttrack at the date of termination, we shall do so and, if reasonably requested, provide
                      you with written confirmation that we have done so.
                    </li>
                    <li>
                      9.4. Termination or expiry of this Agreement shall not affect any accrued rights and liabilities of either party at any time up
                      to the date of termination or expiry and shall not affect any provision of this Agreement that is expressly or by implication
                      intended to continue beyond termination.
                    </li>
                  </ul>

                  <h2>10. Force Majeure </h2>
                  <p>
                    We shall not be liable if we are prevented, hindered or delayed in providing access to the Denttrack or the Content to you due to
                    any cause beyond our reasonable control. We undertake, however, to make reasonable endeavours to overcome any difficulties so
                    occasioned but reserve the right to cancel, suspend or vary our obligations in these circumstances.
                  </p>

                  <h2>11. Indemnity </h2>
                  <ul className="listnone">
                    <li>
                      11.1. You shall indemnify us from and against all liabilities, costs, expenses, damages and losses arising out of or in
                      connection with a third-party claim arising as a result of any unauthorized use of the Denttrack or the Content by you or any
                      Authorised User.
                    </li>
                    <li>
                      11.2. Upon receipt of notice of a claim, action or proceeding in respect of which indemnity may be sought under clause 11.1, we
                      shall promptly notify you in writing and shall not settle any such claim, action or proceeding without your written consent,
                      which shall not be unreasonably withheld. You shall at your own expense assume and control the defence of any litigation or
                      proceeding in respect of which indemnity is sought. We shall provide you with such assistance (at your cost) you may reasonably
                      require.
                    </li>
                  </ul>

                  <h2>12. Limitation of liability </h2>
                  <ul className="listnone">
                    <li>
                      12.1. Without prejudice to the remaining provisions of this clause you agree that your use of Denttrack and the Content is at
                      your sole risk and acknowledge that Denttrack and the Content is provided "as is" and "as available". We make no representations
                      or warranties and, to the fullest extent allowed by law, exclude all implied warranties (including, but not limited to,
                      warranties of satisfactory quality, title and fitness for a particular purpose) regarding Denttrack and the Content and your use
                      of Denttrack and the Content.
                    </li>
                    <li>
                      12.2. Nothing in this Agreement shall exclude or limit either party's liability for fraud or intentional unlawful conduct, or
                      death or personal injury resulting from its negligence.
                    </li>
                    <li>
                      12.3. Neither party shall be liable to the other party for any incidental, punitive, indirect, special or consequential damage,
                      loss or expense, including but not limited to any loss of business, contracts, revenue, or profits, any business interruption,
                      security breach, loss of data, loss of goodwill or reputation or other pecuniary loss suffered by the other party, or any losses
                      arising from any viruses, worms, "Trojan horses" or similar programs.
                    </li>
                    <li>
                      12.4. Without prejudice to the limitation of liability provisions above, if you incur any loss, damage or expense arising out of
                      your authorised use of Denttrack and the Content, you agree that our liability to you under this Agreement shall be limited to
                      the fees for then current Renewal Term in which the claim arose, or in the case of claims during the Initial Term, the fees paid
                      for the Initial Term.
                    </li>
                  </ul>

                  <h2>13. General </h2>
                  <ul className="listnone">
                    <li>
                      13.1. We may at any time assign, sub-contract, transfer, mortgage, charge, declare a trust of or deal in any other manner with
                      any or all of the Licensor's rights or obligations under this Agreement, provided that we give you prior written notice.
                    </li>
                    <li>
                      13.2. Except as expressly permitted by this Agreement, you shall not assign, transfer, sub-licence, mortgage, charge, declare a
                      trust of or deal in any other manner with any or all of your rights or obligations under this Agreement (including the licence
                      rights granted), in whole or in part, without the Licensor's prior written consent.
                    </li>
                    <li>
                      13.3. If any provision of this Agreement is found to be invalid by any court having competent jurisdiction, the invalidity of
                      that provision will not affect the validity of the remaining provisions of this Agreement which shall remain in full force and
                      effect.
                    </li>
                    <li>
                      13.4. This Agreement may not be enforced under the Contracts (Rights of Third Parties) Act 1999 by any person who is not a party
                      to these Standard Terms.
                    </li>
                    <li>
                      13.5. Variation. We reserve the right to change this Agreement at any time. Updated versions of this Agreement will appear on
                      Denttrack and are effective immediately. You are responsible for regularly reviewing this Agreement. Continued use of Denttrack
                      after any such changes constitutes your consent to such changes.
                    </li>
                  </ul>

                  <h2>14. Governing Law and Jurisdiction </h2>
                  <p>
                    This Agreement and any dispute or claim (including non-contractual disputes or claims) arising out of or in connection with it or
                    its subject matter or formation shall be governed by and construed in accordance with the laws of England and Wales and the
                    Parties agree to submit to the exclusive jurisdiction of the English courts in respect of any dispute which may arise in relation
                    to it whether in contract, tort or otherwise.
                  </p>
                </div>
              </div>
            </div>
            <Button variant="primary" onClick={iDoAgree}>
              I Agree
            </Button>
          </Card.Body>
        </Card>
      )}
    </div>
  );
};

export default IAgree;
